export default __webpack_public_path__ + "static/media/08_DAIF_WHY_DELL_04_02_loop.10c55d92.mp4";